import { useSidebar } from "../hooks/useSidebar";
import Sidebar from "./Sidebar";

export default function PageContent({ children, className = "p-6 lg:p-8" }) {
  const { collapsed } = useSidebar();
  return (
    <>
      <Sidebar />
      <main className={`flex-1 ${className} ml-0 transition-[margin] duration-300 ${collapsed ? "lg:ml-[72px]" : "lg:ml-64"}`}>
        {children}
      </main>
    </>
  );
}
